import React from 'react';
import { Icon, InlineError, Tooltip, Typography } from 'glints-aries/es/@next';
import { Input, InputProps } from 'glints-aries/es/@next/Input/Input';
import { Blue, Neutral } from 'glints-aries/es/@next/utilities/colors';

import { StyledLabelWrapper, StyledTextField } from './TextField.sc';

type InputFieldProps = InputProps & {
  label?: string;
  tooltipText?: string;
  subLabel?: string;
  errorText?: string;
  fullWidth?: boolean;
  width?: number;
};

const InputField = React.forwardRef<HTMLInputElement, InputFieldProps>(
  (
    {
      label,
      subLabel,
      tooltipText,
      errorText,
      fullWidth,
      width,
      ...props
    }: InputFieldProps,
    ref
  ) => (
    <StyledTextField data-fullwidth={fullWidth} width={width}>
      <If condition={Boolean(label)}>
        <StyledLabelWrapper>
          <Typography variant="body2">{label}</Typography>
          <If condition={Boolean(tooltipText)}>
            <Tooltip content={tooltipText} preferredPosition="right-middle">
              <Icon
                name="ri-information-line"
                height={20}
                width={20}
                fill={Blue.S99}
                data-cy={'tooltip'}
              />
            </Tooltip>
          </If>
        </StyledLabelWrapper>
      </If>
      <If condition={Boolean(subLabel)}>
        <Typography variant="subtitle2" color={Neutral.B18}>
          {subLabel}
        </Typography>
      </If>
      <Input {...props} ref={ref} error={Boolean(errorText)} />
      <If condition={Boolean(errorText)}>
        <InlineError text={String(errorText)} data-cy={'error-message'} />
      </If>
    </StyledTextField>
  )
);

InputField.displayName = 'InputField';

export default InputField;
